import Layout from "../Layout";
import { Box, Grid } from "@mui/material";
import OperatorsTableList from "../../../widgets/supervisor/operators/OperatorsTableList";

function OperatorsSupervisor() {
  return (
    <Layout>
      <Grid sx={{ mb: 2 }} size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 7 }}>
        <OperatorsTableList />
      </Grid>
    </Layout>
  );
}

export default OperatorsSupervisor;
